<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    data-token-name="IconRaiseHand_16"
    viewBox="0 0 16 16"
    aria-hidden="true"
>
    <path
        fill="currentColor"
        d="M14.33 5.845c-.485-.13-.988.145-1.122.614l-.73 2.551-.88-.235 1.46-5.101a.88.88 0 0 0-.635-1.086c-.486-.13-.99.146-1.123.615L9.838 8.304l-.88-.236 1.704-5.951a.88.88 0 0 0-.636-1.085c-.486-.13-.989.146-1.124.616l-1.704 5.95-.88-.235 1.462-5.1a.88.88 0 0 0-.636-1.087c-.486-.13-.99.146-1.124.616l-2.028 7.08c-.107.374-.626.376-.716-.003-.07-.296-.288-1.399-.443-2.19-.092-.474-.556-.79-1.049-.717A.9.9 0 0 0 1 6.846c.003.677.014 1.686.053 2.528.149 3.283 3.498 4.8 5.123 5.235 2.002.536 3.937.598 5.397-.303 1.005-.619 1.8-1.813 2.182-3.146l1.211-4.231a.877.877 0 0 0-.635-1.084"
    />
</svg>
